/*
 * @Author: sunfei
 * @Date: 2021-10-18 16:30:12
 * @LastEditTime: 2021-10-18 16:30:12
 * @LastEditors: sunfei
 * @Description: async/await 优雅的错误处理方法
 */

/**
 * 使用方法参照 https://www.npmjs.com/package/await-to-js
 * @param { Promise } promise
 * @param { Object= } errorExt - 传递给err对象的附加信息
 * @return { Promise }
 */
function to(promise, errorExt) {
  return promise
    .then(function (data) {
      return [null, data];
    })
    .catch(function (err) {
      if (errorExt) {
        Object.assign(err, errorExt);
      }
      return [err, undefined];
    });
}

export { to };
export default to;
